// extracted by mini-css-extract-plugin
export default {"iframeContainer":"resume_iframeContainer__H8uSQ","mobileContainer":"resume_mobileContainer__AeVEm"};